import { render, staticRenderFns } from "./vaccins.vue?vue&type=template&id=07fea97e&"
import script from "./vaccins.vue?vue&type=script&lang=js&"
export * from "./vaccins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports